export interface IntakeFormData {
  // Step 1 - 기본 정보
  name: string;
  email: string;
  linkedin_url: string;
  target_position: string;
  target_country: string;

  // Step 2 - 현재 상황
  work_experience_years: string;
  industry: string;
  current_situation: string;
  main_concern: string;

  // 유입 경로
  acquisition_channel: string;

  // Step 3 - 파일 첨부
  cv_file: File | null;
  cover_letter_file: File | null;
  jd_file: File | null;
}

export interface IntakeSubmission {
  stripe_session_id: string;
  service_type: string;
  name: string;
  email: string;
  linkedin_url: string | null;
  target_position: string | null;
  target_country: string | null;
  work_experience_years: number | null;
  industry: string | null;
  current_situation: string | null;
  main_concern: string | null;
  cv_file_url: string | null;
  cover_letter_file_url: string | null;
}

export const STEPS = ["기본 정보", "현재 상황", "파일 첨부"] as const;
export type StepIndex = 0 | 1 | 2;
